export const RoutePostCdtTrees_treeId_Reset = "/cdt/trees/:treeId/reset";

export interface ParamsPostCdtTrees_treeId_Reset {
  treeId: string;
}

export interface ResponsePostCdtTrees_treeId_Reset {
  message: string;
}
